import { CrimeType } from "../types/CrimeType";

export const CrimeTypeList: CrimeType[] = [
  {
    id: 0,
    title: "Rob a hot dog vendor",
    percentage: 30,
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/rob-hotdog.png",
  },
  {
    id: 1,
    title: "Rob a freight train",
    percentage: 14,
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/rob-train.png",
  },
  {
    id: 2,
    title: "Rob the bank",
    percentage: 7,
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/rob-bank.png",
  },
  {
    id: 3,
    title: "Bribe the police station",
    percentage: 3,
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/bribe-police.png",
  },
];

export const NickCarTypeList: CrimeType[] = [
  {
    id: 0,
    title: "On the street corner",
    percentage: 30,
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-street-corner.png",
  },
  {
    id: 1,
    title: "At the football stadium",
    percentage: 14,
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-stadium.png",
  },
  {
    id: 2,
    title: "From private residence",
    percentage: 7,
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-private-residence.png",
  },
  {
    id: 3,
    title: "From the dealership",
    percentage: 3,
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-dealership.png",
  },
];
